import { render, staticRenderFns } from "./MarkdownEditor.vue?vue&type=template&id=4fa3226f"
import script from "./MarkdownEditor.vue?vue&type=script&lang=js"
export * from "./MarkdownEditor.vue?vue&type=script&lang=js"
import style0 from "./MarkdownEditor.vue?vue&type=style&index=0&id=4fa3226f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports